import BasicInfo from '../../../Common/BasicInfo';
import Quoter from './Quoter';
import InsuredInfo from './InsuredInfo';
import Beneficiary from './Beneficiary';
import MedicalHistory from './MedicalHistory';
import Payment from './Payment';
import Verify from './Verify';
import Consent from './Consent';
import Sign from './Sign';
import Status from './Status';

export {
  BasicInfo,
  Quoter,
  InsuredInfo,
  Beneficiary,
  MedicalHistory,
  Payment,
  Verify,
  Consent,
  Sign,
  Status,
}



// WEBPACK FOOTER //
// ./src/components/Quoters/Securian/WL/steps/index.js